import {getRequest, postRequest} from "redux-request-middleware";
import {gatewayUrl, shubhSignUrl} from "config";

export enum Actions {
    REQUEST_SAVE_DOCUMENTS_CONSENT = "REQUEST_SAVE_DOCUMENTS_CONSENT",
    REQUEST_SAVE_DOCUMENTATION_MODE = "REQUEST_SAVE_DOCUMENTATION_MODE",
    REQUEST_GET_UNSIGNED_DOCUMENT = "REQUEST_GET_UNSIGNED_DOCUMENT",
    REQUEST_GET_ESIGN_OTP = "REQUEST_GET_ESIGN_OTP",
    REQUEST_VERIFY_ESIGN_OTP = "REQUEST_VERIFY_ESIGN_OTP",
    END_TIMER = "END_TIMER",
    REMOVE_FLAGS = "REMOVE_FLAGS",
    REQUEST_GET_NACH_LINK = "REQUEST_GET_NACH_LINK",
    SHOW_CONSENT_LOADER = "SHOW_CONSENT_LOADER",
    HIDE_CONSENT_LOADER = "HIDE_CONSENT_LOADER",
    CLEAR_NACH_ERROR = "CLEAR_NACH_ERROR",
    SET_PROCESS_MODES = "SET_PROCESS_MODES",
    REQUEST_GET_OPP_ID = "REQUEST_GET_OPP_ID",
    REQUEST_LOAN_OPP = "REQUEST_LOAN_OPP",
    CLEAR_DELAY = "CLEAR_DELAY",
}

export function getActiveOppId() {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_GET_OPP_ID,
                "/hagen/active-opp-id",
                null,
                null,
                null,
                gatewayUrl,
            )
        )
    }
}

export function getLatestLoanOpp(id: string) {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_LOAN_OPP,
                "/loan-opportunity/opportunity",
                {
                    id,
                },
                null,
                null,
                gatewayUrl,
            )
        )
    }
}

export function getUnSignedDoc(request_id: string) {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_GET_UNSIGNED_DOCUMENT,
                "/getunsigneddocs",
                {
                    request_id,
                },
                null,
                null,
                shubhSignUrl,
            ),
        );
    };
}

export function sendOtp(request_id: string) {
    return (dispatch) => {
        dispatch(
            postRequest(
                Actions.REQUEST_GET_ESIGN_OTP,
                "/sendotp",
                {
                    body: {
                        request_id,
                    },
                },
                false,
                null,
                null,
                shubhSignUrl,
            ),
        );
    };
}

export function verifyOtp(esignRequestId: string, otp: number) {
    return (dispatch) => {
        dispatch(
          postRequest(
            Actions.REQUEST_VERIFY_ESIGN_OTP,
            "/verifyotp",
            {
                body: {
                    request_id: esignRequestId,
                    otp,
                },
            },
            false,
            null,
            null,
            shubhSignUrl,
          ),
        );
    };
}

export function endTimer() {
    return { type: Actions.END_TIMER };
}
export const finishDelay = (body) => {
    return {type: Actions.CLEAR_DELAY, body}
}
export function initialNach(oppId: string, nachMode: string, redirectUrl: string = null) {
    return (dispatch) => {
        dispatch(
          postRequest(
            Actions.REQUEST_GET_NACH_LINK,
            `/hagen/initiate-nach`,
            {
                nachMode,
                redirectUrl,
                oppId,
            },
            false,
            null,
            null,
            gatewayUrl,
          ),
        );
    };
}

export function clearinitiationNachError() {
    return { type: Actions.CLEAR_NACH_ERROR };
}

export function removeFlags() {
    return { type: Actions.REMOVE_FLAGS };
}

export function showConsentLoader() {
    return { type: Actions.SHOW_CONSENT_LOADER};
}

export function hideConsentLoader() {
    return { type: Actions.HIDE_CONSENT_LOADER};
}

export function storeProcessModes(body) {
    return {type: Actions.SET_PROCESS_MODES, body};
}
